
import axios from 'axios';
import { NotificationManager } from 'react-notifications';
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
  PROGRAM_INCLUSION_ACTION1,
  GET_PROGRAM_INCLUSION,
  ADD_PROGRAM_INCLUSION1,
  DELETE_PROGRAM_INCLUSIONS,
  EDIT_PROGRAM_INCLUSIONS,
} from 'Actions/types';


export const getProgramInclusion1 = () => {

  return (dispatch) => {
    dispatch({ type: PROGRAM_INCLUSION_ACTION1 });
    return axios.get(AppConfig.apiurl + '/api/getprograminclusions', { headers: AuthHeader.header })
      .then(response => {
        const alldata = response.data.data;
        dispatch({ type: GET_PROGRAM_INCLUSION, payload: alldata });
      });
  }

}

export const addProgramInclusions = (name) => async (dispatch) => {

  var payload = {
    "name": name,
  }
  dispatch({ type: PROGRAM_INCLUSION_ACTION1 });
  axios.post(AppConfig.apiurl + '/api/addprograminclusions', payload, { headers: AuthHeader.header })
    .then(response => {
      if (response.status == 200) {
        var resdata = response.data;
        if (resdata.status === 1) {
          getProgramInclusion1()(dispatch);
          NotificationManager.success(resdata.message);
          dispatch({ type: ADD_PROGRAM_INCLUSION1 });
        } else {
          NotificationManager.error(resdata.message);
        }
      } else {
        NotificationManager.error('Role not added');
      }

    })
    .catch(error => {
      NotificationManager.error(error);
    });
}

export const deleteProgramInclusions = (id) => async (dispatch) => {

  var payload = {
    "id": id
  }
  dispatch({ type: PROGRAM_INCLUSION_ACTION1 });
  axios.post(AppConfig.apiurl + '/api/deleteprograminclusions', payload, { headers: AuthHeader.header })
    .then(response => {
      if (response.status == 200) {
        var resdata = response.data;
        if (resdata.status === 1) {
          getProgramInclusion1()(dispatch);
          NotificationManager.success(resdata.message);
          dispatch({ type: DELETE_PROGRAM_INCLUSIONS });
        } else {
          NotificationManager.error(resdata.message);
        }
      }

    })
    .catch(error => {
      NotificationManager.error(error);
    });
}


export const editProgramInclusions = (name,id) => async (dispatch) => {
    
  var payload={
      "id":id,
      "name":name,
   }
   dispatch({ type: PROGRAM_INCLUSION_ACTION1 });
  axios.post(AppConfig.apiurl+'/api/editprograminclusions', payload, { headers: AuthHeader.header })
   .then( response => {       
       if(response.status==200){ 
          var resdata=response.data;
          if(resdata.status===1){
            getProgramInclusion1()(dispatch);
             NotificationManager.success(resdata.message);               
             dispatch({ type: EDIT_PROGRAM_INCLUSIONS });
          }else{
             NotificationManager.error(resdata.message); 
          }
       }            
       
   })
   .catch( error => { 
     NotificationManager.error(error);
   });
}